/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RuleType = {
    Default: 'Default',
    Penalty: 'Penalty',
    Bonus: 'Bonus'
} as const;
export type RuleType = typeof RuleType[keyof typeof RuleType];


export function RuleTypeFromJSON(json: any): RuleType {
    return RuleTypeFromJSONTyped(json, false);
}

export function RuleTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuleType {
    return json as RuleType;
}

export function RuleTypeToJSON(value?: RuleType | null): any {
    return value as any;
}

